import React from 'react'
import Check from '../../../media/felsv/secondary_check_icon.svg'
import {useSelector} from 'react-redux'
import {State} from '../../../reducers'
import {fechaMayorActual, getFechaCA} from '../../../utils/stringDate'

const CardMiSuscripcion = () => {
  const datos = useSelector((state: State) => state.suscripcion.datosSuscripcion)

  const width = () => {
    if (!isNaN(datos?.facturas_emitidas) && !isNaN(datos?.facturas_maximas)) {
      return `${(datos.facturas_emitidas * 100) / datos.facturas_maximas}%`
    }
    return '0'
  }

  return (
    <div className='card'>
      <h4 className='h4-titles'>Mi Suscripción</h4>
      <div className='separador'></div>
      <div className='card-mi-suscripcion-body' style={{paddingTop: '1%'}}>
        <div>
          <div>
            <p className='card-mi-suscripcion-subtitle'>Plan</p>
            <p className='card-mi-suscripcion-text'>{datos?.plan || ''}</p>
            <p className='card-mi-suscripcion-text'>${datos?.precio || ''} al mes</p>
          </div>
          <div>
            <p className='card-mi-suscripcion-subtitle'>{datos?.estado_cancelacion ? `Fecha de finalización` : `Fecha máxima de pago`}</p>
            <p className='card-mi-suscripcion-text'>{getFechaCA(datos?.fecha_expiracion || '')}</p>
          </div>
          <div className='card-mi-suscripcion-div-button' style={{display:"none"}}>
            <div style={{textAlign: 'center'}}>
              <button type='button' className='m button  w-inline-block w-auto' disabled>
                <div>Pagar plan</div>
              </button>
              {!fechaMayorActual(datos?.fecha_expiracion) && (
                <p className='card-mi-suscripcion-text-success'>
                  <img src={Check} alt='Cambiar mi plan' />
                  Pago al día
                </p>
              )}
            </div>
            <button type='button' className='m button transparent w-inline-block w-auto'>
              <div>Cambiar mi plan</div>
            </button>
          </div>
        </div>
        <div>
          <div>
            <p className='card-mi-suscripcion-subtitle'>Facturas Emitidas</p>
            <div className='car-mi-suscripcion-progress-grey'>
              <div
                className='car-mi-suscripcion-progress-secondary'
                style={{width: `${width()}`}}
              ></div>
            </div>
            <p className='card-mi-suscripcion-text'>
              <span style={{color: '#13AD90'}}>{datos?.facturas_emitidas || '0'}</span> de Facturas
              emitidas de {datos?.facturas_maximas || '0'}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardMiSuscripcion
